import { Component, inject, Input } from '@angular/core';

import { type OfferFull } from '@recruitee/offers-types';
import { getJobRouterLink } from '@recruitee/offers-util';
import type { LayoutListRowComponent } from '@recruitee/views-util';

import { ExtractOfferCountersPipe } from './offer-counters.pipe';
import { StatusChangeDefaultFacade } from '../../facades/status-change-default.facade';
import { StatusChangeFacade } from '../../facades/status-change-facade.types';
import { OffersListItemComponent } from '../../offers-page/offers-list-item/offers-list-item.component';
import { JobsDataSourceService } from '../services/jobs-data-source.service';

@Component({
  selector: 'rt-offer-card-wrapper',
  imports: [OffersListItemComponent, ExtractOfferCountersPipe],
  template: `
    <rt-offers-list-item
      [isVisibleOnScreen]="true"
      [offer]="record"
      [counters]="record | extractOfferCounters: fieldsVisibilityMap"
      [detailsRouterLink]="jobRouterLink"
      [fieldsVisibilityMap]="fieldsVisibilityMap"
      (offerToggleFollow)="onFollowToggle($event)"
    />
  `,
  providers: [{ provide: StatusChangeFacade, useClass: StatusChangeDefaultFacade }],
})
export class OfferListWrapperComponent implements LayoutListRowComponent<OfferFull> {
  @Input() public record: LayoutListRowComponent<OfferFull>['record'];
  @Input() public fieldsVisibilityMap: OffersListItemComponent['fieldsVisibilityMap'];

  private jobsDataSourceService = inject(JobsDataSourceService);

  public onFollowToggle({ followed, id, slug }: { followed: boolean; id: number; slug: string }) {
    this.jobsDataSourceService.toggleOfferFollow({ followed, id, slug });
  }

  public get jobRouterLink(): string[] {
    return getJobRouterLink(this.record);
  }
}
